import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "laptop",
  "use": "laptop-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"laptop\"><defs><path id=\"laptop_a\" d=\"M0 0h24v24H0V0z\" /></defs><clipPath id=\"laptop_b\"><use xlink:href=\"#laptop_a\" overflow=\"visible\" /></clipPath><path clip-path=\"url(#laptop_b)\" d=\"M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol